<script>
    import { onMount } from "svelte";
    import CustomMenu from './CustomMenu.svelte';
    import SettingModal from './SettingModal.svelte';
    import { raumItems, isHackActive, nextHackIndex, hackCuts } from '../../store.js';    
    import { getContext } from 'svelte';
    import DashboardModal from "./DashboardModal.svelte";
    import HackModal from "./HackModal.svelte";
    import {shortcut} from '../../shortcut.js'
    
    const { open } = getContext('simple-modal');
    const showSurprise = () => open(SettingModal);
    const showDashboard = () => open(DashboardModal);
    const showHack = () => open(HackModal);

    let y;
    let video, videoWrapper, resetBtn, btnWrapper;
    let sound;

    onMount(() => {
		video = document.getElementById("myVideo");
		sound = document.getElementById("mySound");
        videoWrapper = document.getElementById("video-wrapper");
        resetBtn = document.getElementById("resetBtn");
        btnWrapper = document.getElementById("btn-wrapper");
	});

    function videofunc() {
        console.log(video.currentTime);
    }

    function draw() {
        if (video.paused) {
            let total = [];
            
            $raumItems.map((item, index) => {
                for(let i = 0; i < item.quantity; ++i) {
                    total.push(index);
                }
            })

            let randomIndex = total[Math.floor(Math.random() * total.length)];

            if($isHackActive) {
                if($nextHackIndex && $nextHackIndex >= 0 && !isNaN($nextHackIndex)) {
                    console.log('got you', $nextHackIndex);
                    
                    if($nextHackIndex < $raumItems.length) {
                        randomIndex = $nextHackIndex - 1;
                    }
                }
            }

            console.log('finally', randomIndex)
            let result = $raumItems[randomIndex];
            
            if(randomIndex === undefined ) return alert('설정해주세요');

            raumItems.update( m => {
                m[randomIndex].quantity -= 1;
                return m;
            })

            videoWrapper.classList.add('play');
            pikachu.src = result.image;
            btnWrapper.classList.add('hide');
            video.play();

            setTimeout(function() {
                pikachu.style.opacity = 1;
            }, 6092);

            setTimeout(function() {
                resetBtn.style.opacity = 1;
            }, 8092);
        } else {
            video.pause();
        }
    }

    function reset() {
        video.pause();
        video.currentTime = 0;
        pikachu.style.opacity = 0;
        resetBtn.style.opacity = 0;
        videoWrapper.classList.remove('play');
        btnWrapper.classList.remove('hide');
    }

</script>

<svelte:window 
    use:shortcut={{
        control: true, alt: false, code: 'Digit0', 
		callback: () => {
            $isHackActive = !$isHackActive;
        }
    }}
	use:shortcut={{
		control: true, alt: false, code: 'Digit1', 
		callback: () => {
            if(!$isHackActive) return;
            $nextHackIndex = hackCuts.c1;
        }
	}} 
	use:shortcut={{
		control: true, alt: false, code: 'Digit2', 
        callback: () => {
            if(!$isHackActive) return;
            $nextHackIndex = hackCuts.c2;
        }	
    }} 
	use:shortcut={{
		control: true, alt: false, code: 'Digit3', 
        callback: () => {
            if(!$isHackActive) return;
            $nextHackIndex = hackCuts.c3;
        }	
    }}
	bind:scrollY={y}
/>
<CustomMenu goSetting={showSurprise} goDashboard={showDashboard} goHack={showHack}/>

<div id="video-wrapper">
    <video on:click={videofunc} id="myVideo">
        <source src="/images/open3.mp4" type="video/mp4">
        Your browser does not support HTML5 video.
    </video>
    <audio id="mySound">
        <source src="/images/mysound.mp3">
        Your browser isn't invited for super fun audio time.
    </audio>
    <div class="pikachu-wrapper">
        <img id="pikachu" src="/images/pikachu.png" alt="pikachu" />
    </div>
    <div class="btn-wrapper">
        <span on:click={reset} id="resetBtn" class='reset-btn'>DRAW</span>
    </div>
</div>
  

<div id="btn-wrapper" class="glow" class:active={$isHackActive}>
    <img id="box" on:mouseover={() => {
        mySound.currentTime = 0;
        mySound.play();
    }} on:mouseout={()=>mySound.pause()} on:click={draw} src="/images/box.svg" alt="mystery box" />
</div>

<style>
    .active {
        animation: float 3s ease-in-out infinite;
    }
    .reset-btn{
        text-align: center;
        display: inline-block;
        margin: 5px;
        font-weight: bold;
        padding: 10px 10px 10px 10px ;
        background-color: lightgray;
        text-shadow: -1px -1px black, 1px 1px white;
        color: #4c4c4c;
        border: 1px solid #6e6e6e;
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        -o-border-radius: 7px;
        border-radius: 7px;
        box-shadow: 0 .2em gray; 
        cursor: pointer;
        font-size: 30pt;
        transition: 0.5s;
        opacity: 0;

    }
    .reset-btn:hover {
        box-shadow: none;
        position: relative;
        transform: translateY(-1.1rem);
    }
    .reset-btn:active {
        box-shadow: none;
        position: relative;
        top: .2em;
    }
    @keyframes float {
        0% {
            transform: translatey(0px);
        }
        50% {
            transform: translatey(-20px);
        }
        100% {
            transform: translatey(0px);
        }
    }
    .pikachu-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
    }

    .btn-wrapper {
        position: absolute;
        /* top: 0; */
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: -40vh;
    }

    #pikachu {
        width: 400px;
        margin: auto;
        transition: 3s;
        opacity: 0;
        transform: translatey(0px);
        animation: float 6s ease-in-out infinite;
    }
    #video-wrapper {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }
    :global(.play) {
        display: block !important;
    }
    :global(.hide) {
        display: none !important;
    }
    .glow {
        transition: 0.5s;
        margin: auto;
        width: 400px;
        height: 400px;
        border-radius: 30%;
        box-shadow: inset 0 0 50px #fff, inset 20px 0 80px #44a35e, inset -20px 0 80px #15c471, inset 20px 0 300px #216ab3, inset -20px 0 300px #9bebf9, 0 0 50px #fff, -10px 0 80px #18c573, 10px 0 80px #0ff;
    }
    @keyframes shakeImg {
        0% { transform: translate(1px, 1px) rotate(0deg); }
        10% { transform: translate(-1px, -2px) rotate(-1deg); }
        20% { transform: translate(-3px, 0px) rotate(1deg); }
        30% { transform: translate(3px, 2px) rotate(0deg); }
        40% { transform: translate(1px, -1px) rotate(1deg); }
        50% { transform: translate(-1px, 2px) rotate(-1deg); }
        60% { transform: translate(-3px, 1px) rotate(0deg); }
        70% { transform: translate(3px, 1px) rotate(-1deg); }
        80% { transform: translate(-1px, -1px) rotate(1deg); }
        90% { transform: translate(1px, 2px) rotate(0deg); }
        100% { transform: translate(1px, -2px) rotate(-1deg); }
    }
    #box {
        width: 100%;
        margin: auto;
        cursor: pointer;
    }
    .glow:hover {
        width: 480px;
        height: 480px;
        animation: shakeImg 1.5s;
        animation-iteration-count: infinite;
    }

    #myVideo {
        /* min-width: 100%;  */
        /* min-height: 100%; */
        width: 100%;
        height: 100vh;
        object-fit: contain;
    }
</style>